// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post çağrılarına bağlanacak.
const mockAnnouncements = [
    {
        id: 1,
        company_name: "KALT Elektronik",
        position: "Pazarlama Management Trainee (Co-op)",
        responsible_name: "Barış Topyıldız",
        location: "İstanbul (Maslak)",
        quota: 5,
        last_application_date: "12.12.2025",
        fee: "Ücretli",
        company_description: "2016 yılında kurulan KALT Elektronik, küçük ev aletleri ve dayanıklı tüketim ürünlerinde dünya çapında birçok güçlü markanın distribütörlüğünü yapmaktadır.",
        qualifications: [
            "Pazarlama ve dijital trendlere meraklı",
            "Sosyal medya ve dijital reklamcılığa ilgi duyan",
            "Excel / PowerPoint kullanımında yetkin",
            "Analitik düşünme becerisine sahip"
        ],
        benefits: [
            "Ücret: görüşmede belirlenecektir",
            "Yemek: var",
            "Servis: var"
        ],
        application_status: "draft"
    },
    {
        id: 2,
        company_name: "Vestel",
        position: "Yazılım Geliştirme Stajyeri (Co-op)",
        responsible_name: "Elif Demir",
        location: "Manisa",
        quota: 3,
        last_application_date: "20.12.2025",
        fee: "Ücretli",
        company_description: "Vestel, beyaz eşya ve elektronik alanında Türkiye'nin önde gelen üreticilerinden biridir.",
        qualifications: [
            "Java veya Python bilgisine sahip",
            "Takım çalışmasına uygun",
            "Problem çözme yeteneği yüksek"
        ],
        benefits: [
            "Ücret: var",
            "Yemek: var",
            "Servis: var"
        ],
        application_status: "draft"
    },
    {
        id: 3,
        company_name: "Türk Telekom",
        position: "Veri Analitiği Stajyeri (Co-op)",
        responsible_name: "Kerem Aydın",
        location: "İstanbul",
        quota: 2,
        last_application_date: "05.01.2026",
        fee: "Ücretsiz",
        company_description: "Türk Telekom, Türkiye'nin lider iletişim ve teknoloji şirketidir.",
        qualifications: [
            "SQL bilgisine sahip",
            "Veri görselleştirme araçlarına aşina",
            "İstatistik temel bilgisi"
        ],
        benefits: [
            "Yemek: var",
            "Servis: yok"
        ],
        application_status: "draft"
    }
];

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockAnnouncements];

    if (filter.company_name) {
        rows = rows.filter((row) => row.company_name.toLowerCase().includes(filter.company_name.toLowerCase()));
    }
    if (filter.location) {
        rows = rows.filter((row) => row.location.toLowerCase().includes(filter.location.toLowerCase()));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const show = async (id) => {
    const row = mockAnnouncements.find((item) => item.id === Number(id));
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

const apply = async (id, formData) => {
    const row = mockAnnouncements.find((item) => item.id === Number(id));
    if (row) {
        row.application_status = "sent";
    }
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

export default {
    getAll,
    show,
    apply
}
